import AxiosInstance from "./axiosInstance";

export const listAllStaff = () => {
  return AxiosInstance.get("/staff")
    .then((res) => {
      if (res.status === 200) return res.data;
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
};
export const getStaffDetails = (id) => {
  return AxiosInstance.get(`/staff/${id}`)
    .then((res) => {
      if (res.status === 200) return res.data;
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
};

export const createStaff = (data) => {
  return AxiosInstance.post("/staff", data)
    .then((res) => {
      if (res.status === 200) return res.data;
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
};
export const disableStaff = (id) => {
  return AxiosInstance.delete(`/staff/${id}`)
    .then((res) => {
      if (res.status === 200) return res.data;
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
};
export const enableStaff = (id) => {
  return AxiosInstance.post(`/staff/${id}/activate`)
    .then((res) => {
      if (res.status === 200) return res.data;
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
};
export const updateStaff = (id, data) => {
  return AxiosInstance.patch(`/staff/${id}`, data)
    .then((res) => {
      if (res.status === 200) return res.data;
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
};
